import ForecastGraphAccordion from './ForecastGraphAccordion';

export default ForecastGraphAccordion;
